/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserFunctionalityAccessReport = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The UserFunctionalityAccessReport model module.
   * @module model/UserFunctionalityAccessReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>UserFunctionalityAccessReport</code>.
   * @alias module:model/UserFunctionalityAccessReport
   * @class
   */
  var exports = function() {
    var _this = this;



  };

  /**
   * Constructs a <code>UserFunctionalityAccessReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserFunctionalityAccessReport} obj Optional instance to populate.
   * @return {module:model/UserFunctionalityAccessReport} The populated <code>UserFunctionalityAccessReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('FunctionalityID')) {
        obj['FunctionalityID'] = ApiClient.convertToType(data['FunctionalityID'], 'Integer');
      }
      if (data.hasOwnProperty('AccessTypeID')) {
        obj['AccessTypeID'] = ApiClient.convertToType(data['AccessTypeID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} FunctionalityID
   * @default 0
   */
  exports.prototype['FunctionalityID'] = 0;
  /**
   * @member {Integer} AccessTypeID
   * @default 0
   */
  exports.prototype['AccessTypeID'] = 0;



  return exports;
}));


